import { createContext } from 'react';

const PortalContext = createContext({
  createPortal() {},
  destroyPortal() {},
  updatePortal() {},
});

export default PortalContext;
